var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 512,
    rx: "15%",
    width: 512
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m386 400c45-42 65-112 53-179h-179v74h102c-4 24-18 44-38 57z",
    fill: "#4285f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m90 341a192 192 0 0 0 296 59l-62-48c-53 35-141 22-171-60z",
    fill: "#34a853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m153 292c-8-25-8-48 0-73l-63-49c-23 46-30 111 0 171z",
    fill: "#fbbc02"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m153 219c22-69 116-109 179-50l55-54c-78-75-230-72-297 55z",
    fill: "#ea4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.f18844c0d40c449f3f5548f8474ec391.svg";
export { ForwardRef as ReactComponent };